import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalHeader: {
    description: 'Header in modal to accept invitation to connect to marketplace.',
    defaultMessage: 'Connect to Fulfillment Provider',
    id: 'V1U4PV',
  },
  modalHeaderNotActive: {
    description: 'Header in modal letting the user know the invitation is no longer active.',
    defaultMessage: 'Invitation Expired',
    id: 'Rkzo3E',
  },
  modalHeaderError: {
    description: 'Title for modal to be shown when an error occurred gathering the invitation status.',
    defaultMessage: 'Error Gathering Invitation Status',
    id: 'lkAXOg',
  },
  modalErrorMessage: {
    description: 'message shown when an error occurred gathering the invitation status.',
    defaultMessage: 'An error occurred while processing your request. Please try again.',
    id: 'MBBWbf',
  },
  connectToMarketPlaceBody: {
    description:
      'Message describing who invited the user to connect to their Marketplace.  Also letting user know what will happen once a connection is established.',
    defaultMessage:
      'You have been invited to connect your ShipStation account to <b>{marketplaceName}</b>. The provider is indicating that your companies have come to an agreement on fulfillment services and you are delegating the fulfillment of specific orders to them via ShipStation.',
    id: 'RVk3ca',
  },
  acceptInviteTermsOrderData: {
    description:
      'Terms user must accept in order to complete the connection.  Order data is is data relevant to the contents of the order.  This includes items, quantities, and shipping address.',
    defaultMessage: 'Access to the required order data that is needed to complete fulfillment',
    id: 'zs8Zmr',
  },
  acceptInviteTermsShippingCarrierAccounts: {
    description:
      'Terms user must accept in order to complete the connection. Shipping carrier accounts are the accounts used to pay for shipping labels.',
    defaultMessage: '\nAccess to your shipping carrier accounts to select services and pay for labels',
    id: 'HA6xCW',
  },
  acceptInviteTermsBrandDocs: {
    description:
      'Terms user must accept in order to complete the connection.  Brand docs are documents that are branded with the company logo and other information.  This includes packing slips and invoices.',
    defaultMessage: 'Access to brand information and branded document templates like packing slips.',
    id: 'aTJx2U',
  },
  inviteNotActiveBody: {
    description: 'Message describing the invite is no longer active and cannot be accepted.',
    defaultMessage:
      'The invitation to connect to {marketplaceName} has expired. If this was unexpected, contact the merchant to request a new invitation.',
    id: 'ZazDk6',
  },
  confirmCheckboxLabel: {
    description: 'Label letting the user know they must confirm the following agreement.',
    defaultMessage: 'Confirm Agreement',
    id: 'Svg9p5',
  },
  confirmCheckboxText: {
    description: 'User Agreement needed to approve connection.',
    defaultMessage: 'I understand this agreement and approve this connection.',
    id: 'b1jTLY',
  },
  cancelButton: {
    description: 'Cancel Invitation button will reject this invitation and close the modal',
    defaultMessage: 'Cancel',
    id: '7bkUrd',
  },
  connectButton: {
    description: 'button to connect',
    defaultMessage: 'Approve Connection',
    id: 'WC2f0E',
  },
  closeButton: {
    description: 'Close Modal button',
    defaultMessage: 'Close',
    id: 'hH6JcF',
  },
  establishingConnectionTitle: {
    description: 'Title informing the user the connection request is being processed',
    defaultMessage: 'Marketplace Connection Establishing',
    id: 'A85cIF',
  },
  establishingConnectionMessage: {
    description: 'Message indicating the connection is being established',
    defaultMessage: 'Establishing connection with {marketplaceName}. Please wait...',
    id: 'i9Zf3J',
  },
  succesfulConnectionTitle: {
    description: 'Title informing the user the connection was successfully established',
    defaultMessage: 'Marketplace successfully connected ',
    id: 'KglXkJ',
  },
  succesfulConnectionMessage: {
    description: 'Message indicating the connection was successfully established',
    defaultMessage:
      'You are now connected with {marketplaceName}. Work directly with your marketplace to configure any additional settings. ',
    id: 'fGgrwQ',
  },
  connectionCancelledTitle: {
    description: 'Title for message informing user that connection was cancelled',
    defaultMessage: 'Marketplace Connection Cancelled',
    id: 'aztEE3',
  },
  connectionCancelledMessage: {
    description: 'message informing user that connection was cancelled by them clicking the cancel button',
    defaultMessage: 'If this was in error, click the link in your connection invite to try again.',
    id: 'xuwAAm',
  },
  failedConnectionTitle: {
    description: 'Title for message informing user that connection request failed',
    defaultMessage: 'Marketplace Connection Error',
    id: 'QrNgVq',
  },
  failedConnectionMessage: {
    description: 'message informing user that connection request failed',
    defaultMessage: 'System error on our side. Please click the link in your email again.',
    id: 'hyehVP',
  },
  defaultMarketplace: {
    id: 'BvjCuN',
    defaultMessage: 'marketplace',
    description: 'message with the default marketplace name',
  },
});

export default messages;
